import React from "react";

export default function Services() {
  return (
    <section id="services" className="w-[90%] md:w-[80%] mx-auto pt-8 pb-28">
      <div className="flex justify-between items-start mt-16 mb-16">
        <div>
          <h3 className="text-[#fbfbff] mb-[40px] md:mb-[48px] text-[36px] md:text-[48px] font-regular">
            Services
          </h3>
          <h4 className="mb-[px] text-[18px] md:text-[20px] md:w-[80%] font-regular text-[#fdfdfd]">
            Helping brands and individuals bring their ideas to life through
            User-friendly Design and reliable development.
          </h4>
        </div>
      </div>

      {/*------------SERVICES BODY-----------*/}
      <div className="flex flex-col flex-col-3 md:flex-row gap-8 md:gap-4">
        {/*-----SERVICE CARD--------- */}
        <div className="bg-gradient-to-r from-slate-500/10 inline-block to-slate-500/20 via-slate-500/20 md:w-1/3 rounded-lg flex flex-col text-center py-[20px] md:py-[24px]">
          <div className="flex justify-between items-center mx-3 md:mx-5">
            <h3 className="text-[22px] md:text-[24px] text-[#fbfbff] font-regular mb-2 text-left">
              UI/UX Design
            </h3>

            {/*  SVG ICON */}
            <div className="flex items-center justify-center bg-[#1E3A8A]/30 rounded-lg w-[52px] h-[42px]">
              {/* <img
                src="https://img.icons8.com/?size=100&id=2778&format=png&color=9D9DA5"
                alt=""
                className="w-[30px] h-[30px] inline-block text-[#1E3A8A]"
              /> */}

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 16 16"
                className="text-[#1d4ed8] "
              >
                <path
                  fill="currentColor"
                  d="M13.747 2.226H2.378a.904.904 0 0 0-.904.904v9.302a.904.904 0 0 0 .904.904h11.368a.904.904 0 0 0 .904-.904V3.13a.904.904 0 0 0-.904-.904m-11.368.775h11.368a.13.13 0 0 1 .129.13v2.712H2.249V3.13A.13.13 0 0 1 2.378 3m-.129 9.431V6.616h3.876v5.943H2.379a.13.13 0 0 1-.13-.129m11.497.129H6.899V6.617h6.976v5.814a.13.13 0 0 1-.129.129"
                />
              </svg>
            </div>
          </div>

          <h4 className="md:text-sm text-[14px] text-gray-300 px-3 md:px-5 pt-7 pb-2 text-left">
            I provide fully responsive and ensure hundred percent pixel-perfect
            UI/ UX Design
          </h4>

          {/* Contact ME */}
          <div className="mx-3 md:mx-4 mt-4">
            <a
              href={`https://wa.me/8801314600405`}
              target="_blank"
              className=" border pl-4 pr-2 text-[18px] py-2 rounded-full border-violet-500/10 flex gap-3 justify-between transition items-center hover:bg-blue-600/80"
            >
              <span>Contact Now</span>
              <span className="w-[28px] h-[28px] flex items-center justify-center bg-white rounded-full text-black">
                <svg
                  className="rotate-45"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>

        {/*-----SERVICE CARD--------- */}
        <div className="bg-gradient-to-r from-slate-500/10 inline-block to-slate-500/20 via-slate-500/20 md:w-1/3 rounded-lg flex flex-col text-center py-[20px] md:py-[24px]">
          <div className="flex justify-between items-center mx-3 md:mx-5">
            <h3 className="text-[22px] md:text-[24px] text-[#fbfbff] font-regular mb-2 text-left leading-[1.2]">
              Frontend Development
            </h3>
            <div className="flex items-center justify-center bg-[#1E3A8A]/30 rounded-lg w-[52px] h-[42px]">
              {/* <img
                src="https://img.icons8.com/?size=100&id=2778&format=png&color=9D9DA5"
                alt=""
                className="w-[30px] h-[30px] inline-block text-[#1E3A8A]"
              /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="38"
                viewBox="0 0 48 48"
                className="text-[#1d4ed8] "
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m36.74 24l-6.37 6.369a2.8 2.8 0 1 0 3.96 3.96l8.35-8.349a2.8 2.8 0 0 0 0-3.96l-8.35-8.35a2.8 2.8 0 0 0-3.96 0L24 20.039l-6.369-6.369a2.8 2.8 0 0 0-3.96 0l-8.35 8.35a2.8 2.8 0 0 0 0 3.96l8.35 8.35a2.8 2.8 0 0 0 3.96 0l18.68-18.68l-2.51 5.411z"
                  stroke-width="1"
                />
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m24 20.039l-12.31 12.31l2.51-5.41L11.26 24l4.39-4.388L20.039 24"
                  stroke-width="1"
                />
              </svg>
            </div>
          </div>

          <h4 className="md:text-sm text-[14px] text-gray-300 px-3 md:px-5 pt-7 pb-2 text-left">
            I have been developing frontend projects using HTML, CSS, React,
            Nextjs, Redux and other technologies.
          </h4>

          {/* Contact ME */}
          <div className="mx-3 md:mx-4 mt-4">
            <a
              href={`https://wa.me/8801314600405`}
              target="_blank"
              className=" border pl-4 pr-2 text-[18px] py-2 rounded-full border-violet-500/10 flex gap-3 justify-between transition items-center hover:bg-blue-600/80"
            >
              <span>Contact Now</span>
              <span className="w-[28px] h-[28px] flex items-center justify-center bg-white rounded-full text-black">
                <svg
                  className="rotate-45"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>

        {/*-----SERVICE CARD--------- */}
        <div className="bg-gradient-to-r from-slate-500/10 inline-block to-slate-500/20 via-slate-500/20 md:w-1/3 rounded-lg flex flex-col text-center py-[20px] md:py-[24px]">
          <div className="flex justify-between items-center mx-3 md:mx-5">
            <h3 className="text-[22px] md:text-[24px] text-[#fbfbff] font-regular mb-2 text-left">
              API Development
            </h3>
            {/*  SVG ICON */}
            <div className="flex items-center justify-center bg-[#1E3A8A]/30 rounded-lg w-[52px] h-[42px]">
              {/* <img
                src="https://img.icons8.com/?size=100&id=2778&format=png&color=9D9DA5"
                alt=""
                className="w-[30px] h-[30px] inline-block text-[#1E3A8A]"
              /> */}

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                className="text-[#1d4ed8] "
              >
                <path
                  fill="currentColor"
                  d="M23.32 7.607a7.43 7.43 0 0 0-4.697-4.275a7.7 7.7 0 0 0-4.356-.05a6.36 6.36 0 0 0-3.334 2.583a4.4 4.4 0 0 0-.922-.881a4.9 4.9 0 0 0-3.104-.831a4 4 0 0 0-2.303 1.322a4.16 4.16 0 0 0-1.001 2.102a3.5 3.5 0 0 0-1.352.23A3.3 3.3 0 0 0 .749 8.929a3.66 3.66 0 0 0-.701 1.743a5 5 0 0 0 .811 3.494c.24.344.52.66.831.942c.204.19.438.345.691.46a.36.36 0 0 0 .5-.14a.34.34 0 0 0-.11-.38a2.4 2.4 0 0 1-.69-.591a4.5 4.5 0 0 1-.501-.741a4.3 4.3 0 0 1-.45-2.864c.076-.56.3-1.089.65-1.532c.232-.294.521-.536.851-.711a2.8 2.8 0 0 1 1.082-.32a5.6 5.6 0 0 1 1.222 0a.28.28 0 0 0 .33-.23a.27.27 0 0 0-.26-.301a8 8 0 0 0-.811-.16a3.7 3.7 0 0 1 1-1.513a3 3 0 0 1 1.813-.84c.503-.055 1.012 0 1.492.16c.505.146.98.38 1.402.69a2.26 2.26 0 0 1 1.002 1.683a.33.33 0 1 0 .65 0a2.6 2.6 0 0 0-.31-1.442a.22.22 0 0 0 .1-.09a5.62 5.62 0 0 1 3.145-2.193a6.64 6.64 0 0 1 3.815.27a6.54 6.54 0 0 1 4.005 3.695a8.1 8.1 0 0 1 .48 5.608a5.3 5.3 0 0 1-.48 1.141c-.197.332-.485.6-.83.771a.34.34 0 0 0-.151.44a.34.34 0 0 0 .44.151c.367-.171.692-.42.952-.73c.35-.455.618-.966.79-1.513a8.77 8.77 0 0 0-.19-6.279"
                />
                <path
                  fill="currentColor"
                  d="M8.41 14.737a3 3 0 0 0-.231-.41a2.3 2.3 0 0 0-.3-.39l-.571-.492a1.31 1.31 0 0 0-1.522-.07c-.336.233-.6.556-.761.932a6.3 6.3 0 0 0-.451 1.431a11.8 11.8 0 0 0-.13 3.495c0 .511.14 1.002.24 1.522a.28.28 0 0 0 .32.25a.3.3 0 0 0 .251-.33q-.108-.736-.11-1.482c0-.36 0-.73.05-1.091q.402.075.811.1q.29.023.58 0q.291.015.582 0a11 11 0 0 0 1.111-.2q.132 1.081.15 2.173a.33.33 0 0 0 .651 0c.074-1.092.05-2.188-.07-3.275a8 8 0 0 0-.6-2.163M7.086 17.14h-.58a4 4 0 0 0-.571 0a4.4 4.4 0 0 0-.631.11c0-.2.06-.41.1-.61s.1-.46.16-.691c.116-.477.298-.936.541-1.362c.14-.23.33-.42.611-.24c.47.38.29.19.771.84c.306.58.525 1.2.65 1.843v.19zm6.931-3.985a5.7 5.7 0 0 0-1.853 0a3.4 3.4 0 0 0-1.171.22a1.25 1.25 0 0 0-.711.971a4.3 4.3 0 0 0 0 .802l.21 2.243l.29 3.074a.29.29 0 1 0 .581 0v-3.194a4.36 4.36 0 0 0 3.205-.691a1.76 1.76 0 0 0 .65-2.414a1.88 1.88 0 0 0-1.201-1.011m-.4 2.914a3.24 3.24 0 0 1-2.214.46h-.09v-1.902a.6.6 0 0 1 .06-.24c.05-.08.15-.09.24-.11q.314-.06.632-.06c.49-.08.99-.08 1.482 0a.84.84 0 0 1 .56.4c.36.59-.11 1.102-.7 1.452zm6.899-2.383a8.3 8.3 0 0 0-1.803-.21q-.504.002-1.001.09c-.51.08-1.001.22-1.512.28a.29.29 0 0 0-.29.28a.28.28 0 0 0 .27.3a9 9 0 0 0 1.782.191h.28c-.05.59-.13 1.182-.16 1.803v3.014a5 5 0 0 0-.65.09c-.471.11-.912.28-1.402.37a.29.29 0 0 0 0 .571a8 8 0 0 0 1.311.07h.791c.27 0 .731 0 1.102-.06a8 8 0 0 0 1.182-.13a.33.33 0 1 0 0-.651c-.521 0-1.002-.17-1.562-.23q.14-.821.17-1.653c0-.28.06-.56.08-.84c.02-.281 0-.561 0-.842a16 16 0 0 0-.24-1.592h.08q.745-.14 1.502-.19a.33.33 0 0 0 .35-.3a.32.32 0 0 0-.28-.361"
                />
              </svg>
            </div>
          </div>

          <h4 className="md:text-sm text-[14px] text-gray-300 px-3 md:px-5 pt-7 pb-2 text-left line-clamp-3">
            I have hands on experiences on Designing API's & developing server
            for backend using Nodejs, Express, MongoDB etc.
          </h4>

          {/* Contact ME */}
          <div className="mx-3 md:mx-4 mt-4">
            <a
              href={`https://wa.me/8801314600405`}
              target="_blank"
              className=" border pl-4 pr-2 text-[18px] py-2 rounded-full border-violet-500/10 flex gap-3 justify-between transition items-center hover:bg-blue-600/80"
            >
              <span>Contact Now</span>
              <span className="w-[28px] h-[28px] flex items-center justify-center bg-white rounded-full text-black">
                <svg
                  className="rotate-45"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}


{
  /*
  
  









*/
}